import React from 'react';
import {
  Bot,
  Brain,
  Briefcase,
  Building,
  Building2,
  Code,
  Coffee,
  Database,
  FileText,
  Globe,
  Heart,
  Image,
  Mail,
  MessageSquare,
  Music,
  Pencil,
  Search,
  Settings,
  Share2,
  ShoppingBag,
  Smile,
  Terminal,
  User,
  Video,
  Zap,
} from 'lucide-react';

export const availableIcons = [
  { icon: Bot, name: 'Bot' },
  { icon: Brain, name: 'Brain' },
  { icon: Briefcase, name: 'Briefcase' },
  { icon: Building, name: 'Building' },
  { icon: Building2, name: 'Building2' },
  { icon: Code, name: 'Code' },
  { icon: Coffee, name: 'Coffee' },
  { icon: Database, name: 'Database' },
  { icon: FileText, name: 'Document' },
  { icon: Globe, name: 'Globe' },
  { icon: Heart, name: 'Heart' },
  { icon: Image, name: 'Image' },
  { icon: Mail, name: 'Mail' },
  { icon: MessageSquare, name: 'Message' },
  { icon: Music, name: 'Music' },
  { icon: Pencil, name: 'Pencil' },
  { icon: Search, name: 'Search' },
  { icon: Settings, name: 'Settings' },
  { icon: Share2, name: 'Share' },
  { icon: ShoppingBag, name: 'Shopping' },
  { icon: Smile, name: 'Smile' },
  { icon: Terminal, name: 'Terminal' },
  { icon: User, name: 'User' },
  { icon: Video, name: 'Video' },
  { icon: Zap, name: 'Zap' },
];

// Create a map for quick lookup
export const iconMap = availableIcons.reduce((acc, { icon, name }) => {
  acc[name] = icon;
  return acc;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}, {} as Record<string, React.ComponentType<any>>);


export const getIconByName = (iconName: string | null, size = 16): React.ReactElement | null => {
  if (!iconName) return null;
  const IconComponent = iconMap[iconName];
  return IconComponent ? React.createElement(IconComponent, { size }) : null;
};
